// // PreviewFolder.js
// import React from "react";
// import { useParams } from "react-router-dom";

// export default function PreviewFolder() {
//   const { dir } = useParams();

//   const modules = React.useMemo(
//     () => import.meta.glob("/src/_preview/**/Component.{js,jsx,ts,tsx}"),
//     []
//   );

//   const loader = React.useMemo(() => {
//     if (!dir) return null;
//     const exts = ["js", "jsx", "ts", "tsx"];
//     for (const ext of exts) {
//       const k = `/src/_preview/${dir}/Component.${ext}`;
//       if (modules[k]) return modules[k];
//     }
//     return null;
//   }, [dir, modules]);

//   const LazyComp = React.useMemo(() => {
//     if (!loader) return null;
//     return React.lazy(loader);
//   }, [loader]);

//   if (!dir) return <div>Error: missing :dir</div>;
//   if (!LazyComp) return <div>Error: missing src/_preview/{dir}/Component.*</div>;

//   return (
//     <React.Suspense fallback={<div>Loading…</div>}>
//       <LazyComp />
//     </React.Suspense>
//   );
// }
// PreviewFolder.js
import React from "react";
import { useParams } from "react-router-dom";

// Scan only once at module load (webpack/Cra)
const req = require.context("./_preview", true, /Component\.(js|jsx|ts|tsx)$/);

export default function PreviewFolder() {
  const { dir } = useParams();
  const [C, setC] = React.useState(null);
  const [err, setErr] = React.useState(null);

  React.useEffect(() => {
    try {
      const key = req.keys().find((k) => k.startsWith(`./${dir}/Component.`));
      if (!key) {
        setErr(new Error(`Missing ./_preview/${dir}/Component.(js|jsx|ts|tsx)`));
        setC(null);
        return;
      }

      const mod = req(key);
      const Comp = mod && mod.default ? mod.default : mod;

      setC(() => Comp);
      setErr(null);
    } catch (e) {
      setErr(e);
      setC(null);
    }
  }, [dir]);

  if (err) return <div>Error: {String(err)}</div>;
  if (!C) return <div>Loading…</div>;
  return <C />;
}
